import type { Framework } from '@toeverything/infra';

import { WorkspaceScope, WorkspaceService } from '../workspace';
import { PDF } from './entities/pdf';
import { PDFPage } from './entities/pdf-page';
import { PDFService } from './services/pdf';

export function configurePDFModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(PDFService)
    .entity(PDF, [WorkspaceService])
    .entity(PDFPage);
}

export { PDFPage } from './entities/pdf-page';
export { PDF, type PDFRendererState, PDFStatus } from './entities/pdf';
export { PdfEditStore } from './edits/edit-store';
export type {
  PdfEdit,
  PdfHighlightEdit,
  PdfInkEdit,
  PdfRect,
  PdfTextAddEdit,
  PdfTextReplaceEdit,
  PdfTextStyle,
  PdfWhiteoutEdit,
} from './edits/types';
export {
  type PageTextLayer,
  type PageTextLine,
  type PageTextSpan,
  type PDFMeta,
  PDFRenderer,
  type TextRect,
} from './renderer';
export { PDFService } from './services/pdf';
